import { getWithParamsRequest } from '@rideiq/api/utils/provider';
import { ApiResponse } from '@rideiq/api/utils/responseTransform';

export async function getCancellationReasons(
  scope: string,
  signal?: AbortSignal
): Promise<ApiResponse<{ reasons: CancelReason[] }>> {
  return getWithParamsRequest('cancellations/reasons', { scope }, signal);
}
